import pubsub from 'pubsub-js';

import * as PUBSUB from './topics';

/**
 * PubSub library instance for application-wide event communication
 *
 * @example
 * ```typescript
 * // Subscribe to an event
 * const token = pubsub.subscribe(PUBSUB.CUSTOMER_ID_CHANGED, (data) => {
 *   console.log('Customer ID changed:', data.customerId);
 * });
 *
 * // Publish an event
 * pubsub.publish(PUBSUB.CUSTOMER_ID_CHANGED, { customerId: '123' });
 *
 * // Unsubscribe
 * pubsub.unsubscribe(token);
 * ```
 */
export { PUBSUB };
export default pubsub;

// Re-export types for convenience
export type { PubSubData, PubSubTopic, PubSubTopics } from './topics';
